export default __webpack_public_path__ + "static/media/Wireframes_Web.d1222e27.png";